import React from 'react'
import { PlainTooltip } from 'src/components/Reusable/Tooltip/PlainTooltip/PlainTooltip'
import {
  TOOLTIP_TRIGGERS,
  TooltipPositions,
} from 'src/components/Reusable/Tooltip/Tooltip'
import { ContentMatchIcon } from './ContentSearch.styles'

export const ContentMatchBadge = ({
  isContentMatch,
}: {
  isContentMatch: boolean
}): JSX.Element | null => {
  if (!isContentMatch) {
    return null
  }
  return (
    <PlainTooltip
      id="content-match-badge"
      tooltipBody="Content matched"
      placement={TooltipPositions.top}
      trigger={[TOOLTIP_TRIGGERS.HOVER, TOOLTIP_TRIGGERS.FOCUS]}
    >
      <ContentMatchIcon />
    </PlainTooltip>
  )
}
